<template>
  <div class="base-password-form-item">
    <span :id="'base-password-label-' + finalName" class="text-sm font-semibold block mb-1"
      :class="[
      {'text-secondary-600' : !publicView},
      {'text-staticsecondary-600' : publicView},
    ]">
      <base-obligatory-icon />{{ label }}
    </span>
    <el-form-item :prop="finalName" :rules="finalRules">
      <el-input 
        :ref="refName"
        show-password 
        :autocomplete="autocomplete" 
        :placeholder="placeholder" 
        type="text"
        class="w-full" 
        v-model="localValue" 
        maxlength='50' 
        :disabled="disabled" 
        :class="{'static-css': publicView}"
        :aria-labelledby="'base-password-label-' + finalName"
        @focus="onFocusElInput"
        @blur="onBlurElInput"
        v-on="$listeners">
        <i v-if="icon" slot="prefix" class="el-input__icon">
          <base-icon size="sm" :name="icon" :ariaHidden="true"/>
        </i>
        <template v-if="localValue && !disabled" slot="suffix">
          <base-clear-input-button
            aria-label="Limpiar campo de contraseña"
            @clear="localValue = ''"
          />
        </template>
      </el-input>
    </el-form-item>
    <el-popover ref="popoverrepeat" placement="top" :title="$t('validation.popup.title')" width="380"
      v-model="visiblePopOver"
      trigger="manual" 
      :tabindex="-1"
      :popper-class="popperClass"
      append-to-body>
      <div> 
        <div><base-icon-pass-validation :validated="validation.numChar" />{{ $t('validation.popup.num_char') }}</div>
        <div><base-icon-pass-validation :validated="validation.numMin" />{{ $t('validation.popup.num_min') }}</div>
        <div><base-icon-pass-validation :validated="validation.charMinus" />{{ $t('validation.popup.char_minus') }}</div>
        <div><base-icon-pass-validation :validated="validation.charMayus" />{{ $t('validation.popup.char_mayus') }}</div>
        <div><base-icon-pass-validation :validated="validation.especial" />{{ $t('validation.popup.especial') }}</div>
        <div v-if="repeat"><base-icon-pass-validation
            :validated="validation.passRepeat" />{{ $t('validation.popup.pass_repeat') }}</div>
      </div>
    </el-popover>
  </div>
</template>
<script>
import { i18n } from '@/i18n'
export default {
  name: 'base-password-form-item',
  props: {
    value: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    repeat: {
      type: Boolean,
      default: false,
    },
    password: {
      type: String,
      default: '',
    },
    autocomplete: {
      type: String,
      default: 'off'
    },
    name: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    publicView: {
      type: Boolean,
      default: false,
    },
    refName: {
      type: String,
      default: 'refBasePasswordFormItem'
    },
  },
  data () {
    return {
      localValue: this.value,
      visiblePopOver: false,
      validation: {
        numChar: false,
        numMin: false,
        charMinus: false,
        charMayus: false,
        especial: false,
        passRepeat: !this.repeat
      },
      rules: [
        { validator: (rule, value, callback) => this.isPasswordValid(rule, value, callback, { validation: this.validation }), trigger: 'blur' }, // Mixin
        { validator: (rule, value, callback) => this.isPasswordValid(rule, value, callback, { validation: this.validation }), trigger: 'change' } // Mixin
      ],
      repeatRules: [
        { validator: (rule, value, callback) => this.isRepeatPasswordValid(rule, value, callback, { validationRepeat: this.validation, checkPassword: this.password }), trigger: 'blur' }, // Mixin
        { validator: (rule, value, callback) => this.isRepeatPasswordValid(rule, value, callback, { validationRepeat: this.validation, checkPassword: this.password }), trigger: 'change' } // Mixin
      ],
    }
  },
  mounted: async function () {
    this.$nextTick(() => {
      // Timeout para esperar a que se rendericen los iconos
      setTimeout(() => {
        const refName = this.refName
        this.fixAccesibilityElInputPassword(this.$refs[refName], this.$i18n.t('aria.elementui.input.password'))
      }, 1000)
    })
  },
  computed: {
    finalName: function () {
      return this.name || `${this.repeat ? 'repeat_' : ''}password`
    },
    label: function () {
      return i18n.t(`configurations.${this.repeat ? 'repeat_' : ''}password`)
    },
    finalRules: function () {
      if (this.repeat) {
        return this.repeatRules
      }
      return this.rules
    },
    popperClass: function () {
      return this.publicView ? 'dark:bg-staticdarkblue dark:border-staticdarkblue-600 dark:text-staticdarkblue-200' : 'dark:bg-darkblue dark:border-darkblue-600 dark:text-darkblue-200'
    }
  },
  watch: {
    repeat: function (value, oldValue) {
      this.validation.passRepeat = !value || this.value === this.password
    },
    value: function (value, oldValue) {
      if (value !== oldValue) {
        this.localValue = value
      }
    },
    localValue: function (value, oldValue) {
      if (value !== oldValue) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    onFocusElInput () {
      this.visiblePopOver = true
    },
    onBlurElInput () {
      this.visiblePopOver = false
    },
  },
}
</script>

<style lang="scss" scoped>

.dark .el-input.static-css .el-input__inner {
  border-color: var(--staticdarkblue-600) !important;
  background-color: var(--staticdarkblue-DEFAULT) !important;
  color: var(--staticdarkblue-300) !important;
}
</style>
